<template>
  <div class="containar">
    <div class="clock-contents-block">
        <div class="">
          <div id="neonclock" class="neon-font" v-bind:class="[foreColor, borderRadius]">
            <span class="bartime">{{ hours }}:{{ minutes }}<span class="barampm">{{ ampm }}</span></span>
          </div>
        </div>
        <div class="set">
          <h3>ネオン色</h3>
          <div class="neon-color-grid">
            <label class="neon-color-option" :class="{ active: color === 'sky' }">
              <input type="radio" value="sky" v-model="color" />
              <div class="neon-color-preview sky-neon"></div>
            </label>
            <label class="neon-color-option" :class="{ active: color === 'blue' }">
              <input type="radio" value="blue" v-model="color" />
              <div class="neon-color-preview blue-neon"></div>
            </label>
            <label class="neon-color-option" :class="{ active: color === 'red' }">
              <input type="radio" value="red" v-model="color" />
              <div class="neon-color-preview red-neon"></div>
            </label>
            <label class="neon-color-option" :class="{ active: color === 'pink' }">
              <input type="radio" value="pink" v-model="color" />
              <div class="neon-color-preview pink-neon"></div>
            </label>
            <label class="neon-color-option" :class="{ active: color === 'lightgreen' }">
              <input type="radio" value="lightgreen" v-model="color" />
              <div class="neon-color-preview lightgreen-neon"></div>
            </label>
          </div>
          
          <h3>かたち</h3>
          <div class="toggle-group">
            <label class="toggle-option" :class="{ active: radius === 'round-border' }">
              <input type="radio" value="round-border" v-model="radius" />
              <span class="toggle-label">丸型</span>
            </label>
            <label class="toggle-option" :class="{ active: radius === 'square-border' }">
              <input type="radio" value="square-border" v-model="radius" />
              <span class="toggle-label">角型</span>
            </label>
          </div>
          
          <h3>配信ソフト用URL</h3>
          <div class="url-description">
            <p>各項目を選択するとURLが自動的に生成されます。</p>
            <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
          </div>
          <div class="url-container">
            <input :value="urlInput + '?color=' + color + '&radius=' + radius" id="target" type="text" readonly class="url-input" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      color: 'sky',
      radius: 'round-border',
      urlInput:'https://ruri.info/tool/neonclock'
    };
  },

  computed: {
    foreColor: function() {
      if (this.color === 'sky') {
        return 'sky-neon';
      }
      else if (this.color === 'blue') {
        return 'blue-neon';
      }
      else if (this.color === 'red') {
        return 'red-neon';
      }
      else if (this.color === 'pink') {
        return 'pink-neon';
      }
      else if (this.color === 'lightgreen') {
        return 'lightgreen-neon';
      }
      else {
        return '';
      }
    },
    borderRadius: function() {
      return this.radius;
    }
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0時は12時として扱う
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?color=' + this.color + '&radius=' + this.radius)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}


#neonclock {
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  color: #fff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: transparent;
  border: 3px solid;
}

.round-border {
  border-radius: 100vh;
}

.square-border {
  border-radius: 10px;
}

.bartime {
  letter-spacing: 0.05em;
  font-size: 52px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.barampm {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 5px;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  box-sizing: border-box;
  margin-left: 24px;
}



.sky-neon {
  color: #0ff;
  text-shadow: 0 0 5px #0ff, 0 0 10px #0ff, 0 0 5px #0ff, 0 0 10px #0ff;
  border-color: #0ff;
  box-shadow: 0 0 5px #0ff, 0 0 10px #0ff, inset 0 0 5px #0ff, inset 0 0 10px #0ff;
}

.blue-neon {
  color: #5271ff;
  text-shadow: 0 0 5px #5271ff, 0 0 10px #5271ff, 0 0 5px #5271ff, 0 0 10px #5271ff;
  border-color: #5271ff;
  box-shadow: 0 0 5px #5271ff, 0 0 10px #5271ff, inset 0 0 5px #5271ff, inset 0 0 10px #5271ff;
}

.red-neon {
  color: #f00;
  text-shadow: 0 0 5px #f00, 0 0 10px #f00, 0 0 20px #f00, 0 0 40px #f00;
  border-color: #f00;
  box-shadow: 0 0 5px #f00, 0 0 10px #f00, inset 0 0 5px #f00, inset 0 0 10px #f00;
}

.pink-neon {
  color: #ff00ff;
  text-shadow: 0 0 5px #ff00ff, 0 0 10px #ff00ff, 0 0 20px #ff00ff, 0 0 40px #ff00ff;
  border-color: #ff00ff;
  box-shadow: 0 0 5px #ff00ff, 0 0 10px #ff00ff, inset 0 0 5px #ff00ff, inset 0 0 10px #ff00ff;
}

.lightgreen-neon {
  color: #7fff00;
  text-shadow: 0 0 5px #7fff00, 0 0 10px #7fff00, 0 0 20px #7fff00, 0 0 40px #7fff00;
  border-color: #7fff00;
  box-shadow: 0 0 5px #7fff00, 0 0 10px #7fff00, inset 0 0 5px #7fff00, inset 0 0 10px #7fff00;
}

.neon-font{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}


/* Color Selection */
.neon-color-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 12px;
}

.neon-color-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
}

.neon-color-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.neon-color-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
}

.neon-color-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.neon-color-preview {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  margin: 0;
}

/* 各色のプレビュー */
.neon-color-preview.sky-neon {
  background-color: #0ff;
}

.neon-color-preview.blue-neon {
  background-color: #5271ff;
}

.neon-color-preview.red-neon {
  background-color: #f00;
}

.neon-color-preview.pink-neon {
  background-color: #ff00ff;
}

.neon-color-preview.lightgreen-neon {
  background-color: #7fff00;
}

/* Toggle Options (かたち) */
.toggle-group {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex: 1;
}

.toggle-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.toggle-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
  background: #ebf8ff;
}

.toggle-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-label {
  display: block;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: #4a5568;
  transition: color 0.2s ease;
}

.toggle-option.active .toggle-label {
  color: #0f172a;
}

/* URL Section */
.url-description {
  margin-top: 12px;
}

.url-description p {
  color: #4a5568;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
}

.url-container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 13px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  background: #f8f9fa;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
  background: #fff;
}

.url-copy-btn {
  height: 2.4em;
  padding: 0 16px;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}
</style>
